import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Main from './pages/Main';
import MainKo from './pages/MainKo';
import MainEn from './pages/MainEn';
import MainJa from './pages/MainJa';
// import MainCommon from './pages/MainCommon';

export default () => {
    
    return (
        <Router basename='/'>
            <Routes>
            <Route exact path="/" element={<Main />} />
            <Route exact path="/en" element={<MainEn />} />
            <Route exact path="/kr" element={<MainKo />} />
            <Route exact path="/jp" element={<MainJa />} />
            </Routes>
        </Router>
    );
    

    //return (<MainKo />);
}